import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Alert, AlertDescription } from "@/Components/ui/alert";

interface BookingAlertProps {
    message: string;
    onClose: () => void;
}

const BookingAlert: React.FC<BookingAlertProps> = ({ message, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 5000); // Auto-dismiss after 5 seconds

        return () => clearTimeout(timer);
    }, [onClose]);

    return (
        <Alert className="bg-white border-brand text-brand">
            <AlertDescription className="flex items-center">
                {message}
                <button
                    onClick={onClose}
                    className="ml-4 p-1 hover:bg-gray-100 rounded"
                >
                    <X className="h-4 w-4" />
                </button>
            </AlertDescription>
        </Alert>
    );
};

export default BookingAlert;